/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { OutputPrecisionEnum } from "./OutputPrecisionEnum";
import {
  OutputPrecisionEnumFromJSON,
  OutputPrecisionEnumFromJSONTyped,
  OutputPrecisionEnumToJSON,
  OutputPrecisionEnumToJSONTyped,
} from "./OutputPrecisionEnum";

/**
 *
 * @export
 * @interface PatchedWaterQualityOutputSettings
 */
export interface PatchedWaterQualityOutputSettings {
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  readonly simulationId?: number;
  /**
   * Create domain wide results file.
   */
  createResults?: boolean;
  /**
   * Output time step in seconds.
   */
  outputTimeStep?: number | null;
  /**
   * Output start time in seconds.
   */
  outputStartTime?: number;
  /**
   * Output end time in seconds.
   */
  outputEndTime?: number;
  /**
   * Single or double precision output.
   *
   * * `1` - single
   * * `2` - double
   */
  outputPrecision?: OutputPrecisionEnum;
  /**
   * Customized output time step in seconds.
   */
  customizedOutputTimeStep?: number | null;
  /**
   * Customized output start time in seconds.
   */
  customizedOutputStartTime?: number;
  /**
   * Customized output end time in seconds.
   */
  customizedOutputEndTime?: number;
  /**
   * Single or double precision output for customized results.
   *
   * * `1` - single
   * * `2` - double
   */
  customizedOutputPrecision?: OutputPrecisionEnum;
}

/**
 * Check if a given object implements the PatchedWaterQualityOutputSettings interface.
 */
export function instanceOfPatchedWaterQualityOutputSettings(
  value: object
): value is PatchedWaterQualityOutputSettings {
  return true;
}

export function PatchedWaterQualityOutputSettingsFromJSON(
  json: any
): PatchedWaterQualityOutputSettings {
  return PatchedWaterQualityOutputSettingsFromJSONTyped(json, false);
}

export function PatchedWaterQualityOutputSettingsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatchedWaterQualityOutputSettings {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"] == null ? undefined : json["id"],
    simulationId: json["simulation_id"] == null ? undefined : json["simulation_id"],
    createResults: json["create_results"] == null ? undefined : json["create_results"],
    outputTimeStep:
      json["output_time_step"] === undefined
        ? undefined
        : json["output_time_step"] === null
        ? null
        : json["output_time_step"],
    outputStartTime: json["output_start_time"] == null ? undefined : json["output_start_time"],
    outputEndTime: json["output_end_time"] == null ? undefined : json["output_end_time"],
    outputPrecision:
      json["output_precision"] == null
        ? undefined
        : OutputPrecisionEnumFromJSON(json["output_precision"]),
    customizedOutputTimeStep:
      json["customized_output_time_step"] === undefined
        ? undefined
        : json["customized_output_time_step"] === null
        ? null
        : json["customized_output_time_step"],
    customizedOutputStartTime:
      json["customized_output_start_time"] == null
        ? undefined
        : json["customized_output_start_time"],
    customizedOutputEndTime:
      json["customized_output_end_time"] == null ? undefined : json["customized_output_end_time"],
    customizedOutputPrecision:
      json["customized_output_precision"] == null
        ? undefined
        : OutputPrecisionEnumFromJSON(json["customized_output_precision"]),
  };
}

export function PatchedWaterQualityOutputSettingsToJSON(
  json: any
): PatchedWaterQualityOutputSettings {
  return PatchedWaterQualityOutputSettingsToJSONTyped(json, false);
}

export function PatchedWaterQualityOutputSettingsToJSONTyped(
  value?: Omit<PatchedWaterQualityOutputSettings, "id" | "simulationId"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    create_results: value["createResults"],
    output_time_step: value["outputTimeStep"],
    output_start_time: value["outputStartTime"],
    output_end_time: value["outputEndTime"],
    output_precision: OutputPrecisionEnumToJSON(value["outputPrecision"]),
    customized_output_time_step: value["customizedOutputTimeStep"],
    customized_output_start_time: value["customizedOutputStartTime"],
    customized_output_end_time: value["customizedOutputEndTime"],
    customized_output_precision: OutputPrecisionEnumToJSON(value["customizedOutputPrecision"]),
  };
}
